export default __webpack_public_path__ + "static/uddacider_apple-a2bac8afdb494cd7558edd1c60c773f4.jpg";